const userBaseURL = process.env.REACT_APP_USER_API_URL || "http://localhost:5001";

function sanitize(value, max = 500) {
  const text = String(value == null ? '' : value);
  return text.length > max ? `${text.slice(0, max)}…` : text;
}

export async function reportFrontendError(payload = {}) {
  try {
    await fetch(`${userBaseURL}/api/v1/telemetry/frontend-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        message: sanitize(payload.message || payload.reason || 'Unknown frontend error'),
        stack: sanitize(payload.stack || '', 4000),
        source: sanitize(payload.source || window.location.pathname || 'frontend'),
        level: sanitize(payload.level || 'error', 20),
        context: payload.context || {},
        href: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (_) {}
}

export function installGlobalErrorMonitoring() {
  window.addEventListener('error', (event) => {
    reportFrontendError({
      message: event.message,
      stack: event.error?.stack || '',
      source: event.filename || 'window.error',
      level: 'error',
      context: { lineno: event.lineno, colno: event.colno },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportFrontendError({
      message: typeof reason === 'string' ? reason : reason?.message || 'Unhandled promise rejection',
      stack: reason?.stack || '',
      source: 'window.unhandledrejection',
      level: 'error',
    });
  });
}
